namespace SPA
{
	export namespace Survey
	{
		export namespace data
		{

			export class SurveyTableDataModel
				extends ui.table.model.AbstractTableModel<Wollmilch.TempSurvey.SurveyObject>
			{

				public constructor( descriptor?: ui.table.model.ITableModelDescriptor )
				{
					super( descriptor );

					this.ModelReader( new SurveyTableDataReader() );
				}

				public buildHeader(): JQuery<HTMLElement>
				{
					return new ui.base.BaseHTMLElement( 'tr' )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'Survey.TABLE.OVERVIEW.objectnumber' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'Survey.TABLE.OVERVIEW.orderno' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'Survey.TABLE.OVERVIEW.product' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'Survey.TABLE.OVERVIEW.lastedited' ) ) )
					.Root();
				}

			}

			export class SurveyTableDataReader
				extends ui.table.DataReader< Wollmilch.TempSurvey.SurveyObject >
			{
				public constructor()
				{
					super();
				}

				public GenerateDataField( p_Data: Wollmilch.TempSurvey.SurveyObject ): JQuery<HTMLElement>
				{
					const link = $(
						new Button(
							{
								title: p_Data.ObjectNumber,
								style: 'link',
								on:
								{
									click: () =>
									{
										app.getGlobalTabControl().addTab(
											p_Data.ObjectNumber,
											new SPA.Survey.Page( p_Data ),
											true
										);
									}
								}
							}
						).getElement()
					).removeClass( 'btn' );

					const ProductName = ( idx: number ): string =>
					{
						let id = 'Product.';
						switch ( idx )
						{
							case 1:		id += 'TempSurvey.InsideOutside'; break;
							case 2:		id += 'TempSurvey.Outside'; break;

							default:	id += 'Unrecognizable'; break;
						}

						return id;
					};

					return new ui.base.BaseHTMLElement( 'tr' )
						.append( new ui.base.BaseHTMLElement( 'td' ).append( link ) )
						.append( new ui.base.BaseHTMLElement( 'td' ).append( p_Data.OrderRef ? p_Data.OrderRef : app.getMessage( 'Survey.GENERAL.noValue' ) ) )
						.append( new ui.base.BaseHTMLElement( 'td' ).append( app.getMessage( ProductName( p_Data.Order.Product ) ) ) )
						.append( new ui.base.BaseHTMLElement( 'td' ).append( p_Data.LastEdited ? p_Data.LastEdited : '' ) )
					.Root();
				}
			}

			export class SurveyPDFTableDataModel
			extends ui.table.model.AbstractTableModel<Wollmilch.TempSurvey.ReportDescription>
		{

			public constructor( descriptor?: ui.table.model.ITableModelDescriptor )
			{
				super( descriptor );

				this.ModelReader( new SurveyPDFTableDataReader() );
			}

			public buildHeader(): JQuery<HTMLElement>
			{
				return new ui.base.BaseHTMLElement( 'tr' )
					.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'Survey.TABLE.PDF.date' ) ) )
					.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'Survey.TABLE.PDF.name' ) ) )
					.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'Survey.TABLE.PDF.kind' ) ) )
					.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'Survey.TABLE.PDF.length' ) ) )
					.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'Survey.TABLE.PDF.action' ) ) )
				.Root();
			}

		}

		 export class SurveyPDFTableDataReader
			extends ui.table.DataReader< Wollmilch.TempSurvey.ReportDescription >
		{
			public constructor()
			{
				super();
			}

			public GenerateDataField( report: Wollmilch.TempSurvey.ReportDescription ): JQuery<HTMLElement>
			{
				// DOWNLOAD
				const btnDownload = ui.$$.button()
				.on( 'click', () => this.loadBlob( report.Artifact, ( data: Wollmilch.ArtifactDownload ) => this.downloadFile( data ) ) )
				.append( ui.$$.span().addClass( 'fa fa-download' ) )
				.addClass( 'btn btn-default' )
				.css(
					{
						width:	'32px',
						height:	'24px',
						padding: '2px 8px',
						margin:	'0px 3px'
					}
				);
				// Anzeige
				const btnDisplay = ui.$$.button()
				.on(
					'click',
					() => this.loadBlob(
						report.Artifact, ( data: any ) =>
						{
							const srcStr = 'data:' + data.MimeType + ';' + ( data.Base64 ? 'base64,' : '' );

							let modal: ui.dialog.Modal;

							modal = new ui.dialog.Modal(
								{
									size: 'lg',
									head:	[],
									body: [ ui.$$.iframe()
										.attr('src', srcStr + data.Blob )
										.attr('style', 'height:460px; width:100%; display:block') ],
										foot: []
								}
							);
							modal.on( 'click', () => modal.Hide() );
						}
					)
				)
				.append( ui.$$.span().addClass( 'fa fa-tv' ) )
				.addClass( 'btn btn-info' )
				.css(
					{
						width:	'32px',
						height:	'24px',
						padding: '2px 8px',
						margin:	'0px 3px'
					}
				);

				let fa_MimeType = 'fa-file-o';
				switch (report.Artifact.MimeType)
				{
					case 'application/pdf':
						fa_MimeType = 'fa-file-pdf-o';
						break;
					case 'image/jpeg':
						fa_MimeType = 'fa-file-image-o';
						break;
				}

				let fileLength: any = Math.round(report.Artifact.DataLength / 1000);
				( fileLength > 1000 ) ? fileLength = fileLength.toString() + app.getMessage( 'Survey.TABLE.PDF.fileLength_MB' ) : fileLength = fileLength.toString() + app.getMessage( 'Survey.TABLE.PDF.fileLength_kB' );

				return new ui.base.BaseHTMLElement( 'tr' )
					.append( new ui.base.BaseHTMLElement( 'td' ).append( new Date( report.CreatedAt ).pattern( 'd.m.Y H:i' ) ) )
					.append( new ui.base.BaseHTMLElement( 'td' ).append( report.Artifact.Identifier ) )
					.append( new ui.base.BaseHTMLElement( 'td' ).append( ui.$$.span().addClass( 'fa ' + fa_MimeType ) ) )
					.append( new ui.base.BaseHTMLElement( 'td' ).append( fileLength ) )
					.append( new ui.base.BaseHTMLElement( 'td' ).append( btnDisplay ).append( btnDownload ) )
				.Root();
			}

			private loadBlob( artifact: Wollmilch.ArtifactObject, onsuccess: ( data: Wollmilch.ArtifactDownload ) => void )
			{
				new Wollmilch.AJAX(
					{
						url: 'artifact/download/' + artifact.ID,
						method: 'GET',
						on:
						{
							success: ( text: string ) =>
							{
								const obj = Wollmilch.jsonize( text );

								if ( !obj || obj.success === false )
								{
									return;
								}
							 onsuccess( obj.data );
							}
						}
					}
				).send();
			}

			private downloadFile( data: Wollmilch.ArtifactDownload )
			{
				const srcStr = 'data:' + data.MimeType + ';' + ( data.Base64 ? 'base64,' : '' );
				const element = document.createElement('a');
				element.setAttribute( 'href', srcStr + data.Blob );
				/* TODO sobald in der DB der Dateiname des Artefaktes mitgespeichert wird, diesen verwenden */
				element.setAttribute( 'download', 'downloadfile.bin' /* TODO data.Filename*/ );

				element.style.display = 'none';
				document.body.appendChild(element);

				element.click();

				document.body.removeChild(element);
			}

		}

		 export class SurveyMessageTableDataModel
		extends ui.table.model.AbstractTableModel<Wollmilch.TempSurvey.SurveyMessage>
	{

		public constructor( descriptor?: ui.table.model.ITableModelDescriptor )
		{
			super( descriptor );

			this.ModelReader( new SurveyMessageTableDataReader() );
		}

		public buildHeader(): JQuery<HTMLElement>
		{
			return new ui.base.BaseHTMLElement( 'tr' )
				.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'Survey.TABLE.MESSAGE.createdat' ) ) )
				.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'Survey.TABLE.MESSAGE.text' ) ) )
			.Root();
		}

	}

	  export class SurveyMessageTableDataReader
		extends ui.table.DataReader< Wollmilch.TempSurvey.SurveyMessage >
	{
		public constructor()
		{
			super();
		}

		public GenerateDataField( message: Wollmilch.TempSurvey.SurveyMessage ): JQuery<HTMLElement>
		{
			return new ui.base.BaseHTMLElement( 'tr' )
				.append( new ui.base.BaseHTMLElement( 'td' ).append( new Date(parseInt(message.timestamp) * 1000).pattern( 'd.m.Y H:i' ) ).attr('style', 'white-space: nowrap') )
				.append( new ui.base.BaseHTMLElement( 'td' ).append( message.Text ).attr('style', 'white-space: pre-line') )
			.Root();
		}

		private loadBlob( artifact: Wollmilch.ArtifactObject, onsuccess: ( data: Wollmilch.ArtifactDownload ) => void )
		{
			new Wollmilch.AJAX(
				{
					url: 'artifact/download/' + artifact.ID,
					method: 'GET',
					on:
					{
						success: ( text: string ) =>
						{
							const obj = Wollmilch.jsonize( text );

							if ( !obj || obj.success === false )
							{
								return;
							}
						 onsuccess( obj.data );
						}
					}
				}
			).send();
		}

		private downloadFile( data: Wollmilch.ArtifactDownload )
		{
			const srcStr = 'data:' + data.MimeType + ';' + ( data.Base64 ? 'base64,' : '' );
			const element = document.createElement('a');
			element.setAttribute( 'href', srcStr + data.Blob );
			/* TODO sobald in der DB der Dateiname des Artefaktes mitgespeichert wird, diesen verwenden */
			element.setAttribute( 'download', 'downloadfile.bin' /* TODO data.Filename*/ );

			element.style.display = 'none';
			document.body.appendChild(element);

			element.click();

			document.body.removeChild(element);
		}

	}

		}
	}
}
